import { Phone } from "lucide-react";
import { Logo } from "@/components/Logo";
import { PHONE_DISPLAY, PHONE_TEL } from "@/siteConfig";

const Navbar = () => (
    <header
        data-testid="navbar"
        className="fixed top-0 inset-x-0 z-50 border-b border-white/5 bg-[#0B0F17]/70 backdrop-blur-xl"
    >
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
            <a href="#hero" data-testid="navbar-brand" className="flex items-center gap-3">
                <Logo size={38} />
                <div className="leading-tight">
                    <span className="font-display block text-lg font-black text-white">
                        المفتاح الذهبي
                    </span>
                    <span className="block text-[11px] font-medium text-amber-500">
                        مفاتيح سيارات · فتح أبواب
                    </span>
                </div>
            </a>

            <nav data-testid="navbar-links" className="hidden items-center gap-6 lg:flex">
                <a href="#services" className="text-sm font-bold text-gray-300 transition-colors hover:text-amber-400">الخدمات</a>
                <a href="#gallery" className="text-sm font-bold text-gray-300 transition-colors hover:text-amber-400">أعمالنا</a>
                <a href="#faq" className="text-sm font-bold text-gray-300 transition-colors hover:text-amber-400">الأسئلة الشائعة</a>
                <a href="#location" className="text-sm font-bold text-gray-300 transition-colors hover:text-amber-400">الموقع والأوقات</a>
            </nav>

            <div className="flex items-center gap-3">
                <span
                    data-testid="navbar-status"
                    className="hidden items-center gap-2 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1.5 text-xs font-bold text-emerald-400 sm:flex"
                >
                    <span className="animate-pulse-dot h-2 w-2 rounded-full bg-emerald-400" />
                    متاح الآن 24/7
                </span>
                <a
                    href={PHONE_TEL}
                    data-testid="navbar-call-button"
                    className="cta-shine flex items-center gap-2 rounded-full bg-amber-500 px-4 py-2 text-sm font-extrabold text-[#0B0F17] transition-colors duration-300 hover:bg-amber-400"
                >
                    <Phone size={15} strokeWidth={2.6} />
                    <span dir="ltr">{PHONE_DISPLAY}</span>
                </a>
            </div>
        </div>
    </header>
);

export default Navbar;
